import { render, staticRenderFns } from "./sectionDetailsBlack.vue?vue&type=template&id=a9f70bd0&"
import script from "./sectionDetailsBlack.vue?vue&type=script&lang=js&"
export * from "./sectionDetailsBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports